<div class="layout-row align-center bgr bgr-electric-purple trial-us">
  <div class="flex row-desktop">
    <div class="img-holder section-img rounded">
      <img [src]="cdnPath + '/develop/join-today.jpg?v=1'" alt="" />
    </div>
    <div class="layout-column align-center copy-wrapper half-section">
      <h2 class="txt-white">Join for free & start learning instantly</h2>
      <p class="txt-white">Debit card + app + Money Missions</p>
      <h3 class="txt-white">1 month free, then £3.99/month</h3>
      <a id="" class="btn btn-primary" href="//signup.gohenry.com/uk/parent-details/" rel="noopener">Get started today</a>
      <p class="small disclaimer txt-white">Set up your card in minutes. Cancel anytime.</p>
    </div>
  </div>
</div>
